import ViewContainer from './container'
import { StyledNewsWrapper } from '../styles'
import { Image, Col, Spin } from 'antd'
import NewsCard from 'components/NewsCard'

export default function Index ({ ...pageProps }) {
  return (
    <ViewContainer {...pageProps}>
      {({ state }) => (
        <Spin spinning={state.news.status === 1}>
          <StyledNewsWrapper justify="center" align="middle" gutter={[16, 16]}>
            {state.news.status === 3 ||
              (state.news.status === 2 && state.news.payload.count === 0) ||
              (state.news.status === 2 && state.news.payload.length === 0 && (
                <Col style={{ textAlign: 'center' }} span={24}>
                  <Image
                    preview={false}
                    alt="Peri Peri News"
                    src="/images/empty-news.png"
                  />
                  <h2>You currently have no news.</h2>
                </Col>
              ))}
            {state.news.status === 2 &&
              state.news.payload.map((data) => (
                <Col key={data.id} md={24} lg={12}>
                  <NewsCard
                    id={data.id}
                    title={data.title}
                    image={data.thumbnail_image}
                    description={data.details.description}
                  />
                </Col>
              ))}
          </StyledNewsWrapper>
        </Spin>
      )}
    </ViewContainer>
  )
}
